import axios from "axios";
import { clearAllCachevalue, localClearAll, localGetItem, localSetItem } from "../../Utility/Services/CacheProviderService";

// const LOCAL_BASE_DOMAIN = "http://192.168.0.53:8000/" //DEV API URL
// const LOCAL_BASE_DOMAIN = "https://devv4api.emedhub.in/" //DEV API 
const LOCAL_BASE_DOMAIN = "https://qaapi.ayurveda.emedhub.in/" // QA API
// const LOCAL_BASE_DOMAIN = "https://uatapi.ayurveda.emedhub.in/"; //UAT API URL
// const LOCAL_BASE_DOMAIN = "https://api.emedhub.in/"; //Production API URL

// ========== ⚠️ DO NOT TOUCH THIS CODE — ENVIRONMENT WILL BREAK ⚠️ ========== STARTS ====
const hostname = window.location.hostname;
const subdomain = hostname?.split('.')[0];
let BASE_DOMAIN;
switch (subdomain) {
  case "localhost": BASE_DOMAIN = LOCAL_BASE_DOMAIN; break; // Local development setup
  case "devv4app": BASE_DOMAIN = "https://devv4api.emedhub.in/"; break; // Dev server
  case "qaapp": BASE_DOMAIN = "https://qaapi.ayurveda.emedhub.in/"; break; // QA server
  case "uatapp": BASE_DOMAIN = "https://uatapi.ayurveda.emedhub.in/"; break; // UAT server
  case "test": BASE_DOMAIN = "https://test.api.emedhub.in/"; break; // Test server
  case "app": BASE_DOMAIN = "https://api.emedhub.in/"; break; // common live server
  default: BASE_DOMAIN = LOCAL_BASE_DOMAIN; break; // error Fallback
}
// ========== ⚠️ DO NOT TOUCH THIS CODE — ENVIRONMENT WILL BREAK ⚠️ ========== ENDS =====

const App_Version = 1.1
const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const APP_Version_Label = "v-4.14.2";
export const APP_Support_Label = "Call us: 7397757434, 9500468385"
class RestAPIService {
  getAll = async (URL) => {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error("No connection available"));
    }
    try {
      const response = await axios.create({
        baseURL: BASE_DOMAIN,
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + localGetItem("AccessToken"),
          "USEHOST": "replica_1"
        }
      }).get("/" + URL);

      const { data } = response;

      if (data?.version !== App_Version && typeof data === "object") {
        localClearAll();
        clearAllCachevalue();
        setTimeout(() => {
          window.location.href = window.location.origin
        }, 1000);
        return response;
      } else {
        if (data?.show_sms_alert) {
          localSetItem("show_sms_alert", true);
        } else {
          localSetItem("show_sms_alert", false);
        }
        if (data?.show_whatsapp_alert) {
          localSetItem("show_whatsapp_alert", true)
        } else {
          localSetItem("show_whatsapp_alert", false)
        }

        return response
      }
    } catch (error) {
      if (error?.response && error?.response?.status === 401) {
        // comment for time zone
        // localClearAll();
        // clearAllCachevalue();
        // setTimeout(() => {
        //   window.location.href = window.location.origin
        // }, 1000);
      }
      return Promise.reject(error);
    }
  };

  getAllTwo = async (URL) => {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No connection available'));
    }
    try {
      const response = await axios.create({
        baseURL: BASE_DOMAIN,
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + localGetItem("AccessToken")
        }
      }).get("/" + URL);
      const { data } = response
      if (data?.version != App_Version && typeof (data) === "object") {
        localClearAll()
        clearAllCachevalue()
        setTimeout(() => {
          window.location.href = window.location.origin
        }, 1000);
        return response
      } else {
        if (data?.show_sms_alert) {
          localSetItem("show_sms_alert", true)
        } else {
          localSetItem("show_sms_alert", false)
        }
        if (data?.show_whatsapp_alert) {
          localSetItem("show_whatsapp_alert", true)
        } else {
          localSetItem("show_whatsapp_alert", false)
        }
        return response
      }

    } catch (error) {
      if (error?.response && error?.response?.status === 401) {
        // comment for time zone
        // localClearAll();
        // clearAllCachevalue();
        // setTimeout(() => {
        //   window.location.href = window.location.origin
        // }, 1000);
      }
      return Promise.reject(error);
    }
  }

  getAllPrint = async (URL) => {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No connection available'));
    }
    try {
      const response = await axios.create({
        baseURL: BASE_DOMAIN,
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + localGetItem("AccessToken")
        }
      }).get("/" + URL);
      const { data } = response
      if (data?.version != App_Version && typeof (data) === "object") {
        localClearAll()
        clearAllCachevalue()
        setTimeout(() => {
          window.location.href = window.location.origin
        }, 1000);
        return response
      } else {
        if (data?.show_sms_alert) {
          localSetItem("show_sms_alert", true)
        } else {
          localSetItem("show_sms_alert", false)
        }
        if (data?.show_whatsapp_alert) {
          localSetItem("show_whatsapp_alert", true)
        } else {
          localSetItem("show_whatsapp_alert", false)
        }
        return response
      }

    } catch (error) {
      if (error?.response && error?.response?.status === 401) {
        // comment for time zone
        // localClearAll();
        // clearAllCachevalue();
        // setTimeout(() => {
        //   window.location.href = window.location.origin
        // }, 1000);
      }
      return Promise.reject(error);
    }
  }

  get(id, URL) {
    return axios.create({
      baseURL: BASE_DOMAIN,
      headers: {
        "Content-type": "application/json",
        "Authorization": "Token " + localGetItem("AccessToken"),
        "USEHOST": "replica_1"
      }
    }).get(`/${URL}/${id}`);
  }

  getListbyData(id, data, URL) {
    return axios.create({
      baseURL: BASE_DOMAIN,
      headers: {
        "Content-type": "application/json",
        "Authorization": "Token " + localGetItem("AccessToken"),
        "USEHOST": "replica_1"
      }
    }).get(`${URL}/${id}`, data);
  }

  // create(data, URL) {
  //   let Token = localGetItem("AccessToken") ? localGetItem("AccessToken") : localGetItem("LoginAuthToken")
  //   if (!window.navigator.onLine) {
  //     return Promise.reject(new Error('No internet connection available'));
  //   } else {
  //     return axios.create({
  //       baseURL: BASE_DOMAIN,
  //       headers: {
  //         "Content-type": "application/json",
  //         "Authorization": "Token " + Token
  //       }
  //     }).post("/" + URL, data);
  //   }
  // }

  create = async (data, URL) => {
    let Token = localGetItem("AccessToken") ? localGetItem("AccessToken") : localGetItem("LoginAuthToken");

    if (!window.navigator.onLine) {
      return Promise.reject(new Error("No internet connection available"));
    }

    try {
      const response = await axios.create({
        baseURL: BASE_DOMAIN,
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + Token,
          "X-Client-Timezone": timeZone,
        }
      }).post("/" + URL, data);

      return response;
    } catch (error) {
      if (error?.response && error?.response?.status === 401) {
        // comment for time zone
        // localClearAll();
        // clearAllCachevalue();
        // setTimeout(() => {
        //   window.location.href = window.location.origin
        // }, 1000);
      }
      return Promise.reject(error);
    }
  };

  NewCreate = async (data, URL) => {
    let Token = localGetItem("AccessToken") ? localGetItem("AccessToken") : localGetItem("LoginAuthToken");

    if (!window.navigator.onLine) {
      return Promise.reject(new Error("No internet connection available"));
    }

    try {
      const headers = {
        "Authorization": "Token " + Token,
        "X-Client-Timezone": timeZone,
      };

      // 👇 Only set JSON header if not FormData
      if (!(data instanceof FormData)) {
        headers["Content-Type"] = "application/json";
      }

      const response = await axios.create({
        baseURL: BASE_DOMAIN,
        headers
      }).post("/" + URL, data);

      return response;
    } catch (error) {
      if (error?.response && error?.response?.status === 401) {
        // comment for time zone
        // localClearAll();
        // clearAllCachevalue();
        // setTimeout(() => {
        //   window.location.href = window.location.origin
        // }, 1000);
      }
      return Promise.reject(error);
    }
  };

  // update(id, data, URL) {
  //   if (!window.navigator.onLine) {
  //     return Promise.reject(new Error('No internet connection available'));
  //   } else {
  //     return axios.create({
  //       baseURL: BASE_DOMAIN,
  //       headers: {
  //         "Content-type": "application/json",
  //         "Authorization": "Token " + localGetItem("AccessToken")
  //       }
  //     }).put(`/${URL}/${id}`, data);
  //   }
  // }

  update = async (id, data, URL) => {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error("No internet connection available"));
    }

    try {
      const response = await axios.create({
        baseURL: BASE_DOMAIN,
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + localGetItem("AccessToken"),
          "X-Client-Timezone": timeZone,
        }
      }).put(`/${URL}${id}/`, data);

      return response;
    } catch (error) {
      if (error?.response && error?.response?.status === 401) {
        // comment for time zone
        // localClearAll();
        // clearAllCachevalue();
        // setTimeout(() => {
        //   window.location.href = window.location.origin
        // }, 1000);
      }
      return Promise.reject(error);
    }
  };

  delete(URL, Data) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    } else {
      return axios.create({
        baseURL: BASE_DOMAIN,
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + localGetItem("AccessToken")
        }
      }).delete("/" + URL, { data: Data });
    }
  }

  deleteAll(URL) {
    return axios.create({
      baseURL: BASE_DOMAIN,
      headers: {
        "Content-type": "application/json",
        "Authorization": "Token " + localGetItem("AccessToken")
      }
    }).delete(`/${URL}`);
  }

  findByTitle(title, URL) {
    return axios.create({
      baseURL: BASE_DOMAIN,
      headers: {
        "Content-type": "application/json",
        "Authorization": "Token " + localGetItem("AccessToken"),
        "USEHOST": "replica_1",
        "X-Client-Timezone": timeZone,
      }
    }).get(`/${URL}?title=${title}`);
  }

  // updateWithOutId(data, URL) {
  //   if (!window.navigator.onLine) {
  //     return Promise.reject(new Error('No internet connection available'));
  //   } else {
  //     return axios.create({
  //       baseURL: BASE_DOMAIN,
  //       headers: {
  //         "Content-type": "application/json",
  //         "Authorization": "Token " + localGetItem("AccessToken")
  //       }
  //     }).put(`/${URL}`, data)
  //   }
  // }

  NewupdateWithOutId = async (data, URL) => {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error("No internet connection available"));
    }

    try {
      const headers = {
        "Authorization": "Token " + localGetItem("AccessToken"),
        "X-Client-Timezone": timeZone,
      };
      if (!(data instanceof FormData)) {
        headers["Content-Type"] = "application/json";
      }

      const response = await axios.create({
        baseURL: BASE_DOMAIN,
        headers
      }).put(`/${URL}`, data);

      return response;
    } catch (error) {
      if (error?.response && error?.response?.status === 401) {
        // comment for time zone
        // localClearAll();
        // clearAllCachevalue();
        // setTimeout(() => {
        //   window.location.href = window.location.origin
        // }, 1000);
      }
      return Promise.reject(error);
    }
  }

  updateWithOutId = async (data, URL) => {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error("No internet connection available"));
    }

    try {
      const response = await axios.create({
        baseURL: BASE_DOMAIN,
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + localGetItem("AccessToken"),
          "X-Client-Timezone": timeZone,
        }
      }).put(`/${URL}`, data);

      return response;
    } catch (error) {
      if (error?.response && error?.response?.status === 401) {
        // comment for time zone
        // localClearAll();
        // clearAllCachevalue();
        // setTimeout(() => {
        //   window.location.href = window.location.origin
        // }, 1000);
      }
      return Promise.reject(error);
    }
  }
  patch(data, URL) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    } else {
      return axios.create({
        baseURL: BASE_DOMAIN,
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + localGetItem("AccessToken"),
          "X-Client-Timezone": timeZone,
        }
      }).patch(`/${URL}`, data);
    }
  }

  NewPatch = async (data, URL) => {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    }
    else{
      const headers = {
        "Authorization": "Token " + localGetItem("AccessToken"),
        "X-Client-Timezone": timeZone,
      };

      if (!(data instanceof FormData)) {
        headers["Content-Type"] = "application/json";
      }

      const response = await axios.create({
        baseURL: BASE_DOMAIN,
        headers
      }).patch("/" + URL, data);

      return response;
    }
  }

  
  excelGetAccReport(URL) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    } else {
      return axios.create({
        baseURL: BASE_DOMAIN,
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + localGetItem("AccessToken"),
        },
        responseType: 'blob'
      }).get("/" + URL);
    }
  }
  excelGet(URL) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    } else {
      return axios.create({
        baseURL: BASE_DOMAIN,
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + localGetItem("AccessToken"),
          "USEHOST": "replica_1"
        },
        responseType: 'blob'
      }).get("/" + URL);
    }
  }
  PrintPDF(URL) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    } else {
      return axios.create({
        baseURL: BASE_DOMAIN,
        headers: {
          "Content-type": "application/pdf",
          "Authorization": "Token " + localGetItem("AccessToken")
        },
        responseType: 'blob',
      }).get("/" + URL);
    }
  }

  // LoginAuthGetModules = async(URL) => {
  //   if (!window.navigator.onLine) {
  //     return Promise.reject(new Error('No internet connection available'));
  //   } else {
  //     const response = await axios.create({
  //       baseURL: BASE_DOMAIN,
  //       headers: {
  //         "Content-type": "application/json",
  //         "Authorization": "Token " + localGetItem("LoginAuthToken")
  //       }
  //     }).get("/" + URL);
  //     const  {data} = response
  //     if(data?.version != App_Version && typeof(data) === "object"){
  //       localClearAll()
  //       clearAllCachevalue()
  //       setTimeout(() => {
  //         window.location.reload(true)
  //       }, 1000);
  //       return response
  //     }else{
  //       return response
  //     }
  //   }
  // }

  LoginAuthGetModules = async (URL) => {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error("No internet connection available"));
    }

    try {
      const response = await axios.create({
        baseURL: BASE_DOMAIN,
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + localGetItem("LoginAuthToken"),
        },
      }).get("/" + URL);

      const { data } = response;

      if (data?.version !== App_Version && typeof data === "object") {
        localClearAll();
        clearAllCachevalue();
        setTimeout(() => {
          window.location.href = window.location.origin
        }, 1000);
        return response;
      } else {
        return response;
      }
    } catch (error) {
      if (error?.response && error?.response?.status === 401) {
        // comment for time zone
        // localClearAll();
        // clearAllCachevalue();
        // setTimeout(() => {
        //   window.location.href = window.location.origin
        // }, 1000);
      }
      return Promise.reject(error);
    }
  };


  OPTICAL_CRM_POST(data) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    } else {
      return axios.create({
        baseURL: "https://api.opticalcrm.com",
        headers: {
          "Content-type": "application/json",
          "Token": localGetItem("OPTICAL_CRM_API_TOKEN")
        }
      }).post("/" + "sales_details.php", data);
    }
  }

  OPTICAL_CRM_POST_WITH_URL(url, data) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    } else {
      return axios.create({
        baseURL: "https://api.opticalcrm.com",
        headers: {
          "Content-type": "application/json",
          "Token": localGetItem("OPTICAL_CRM_API_TOKEN")
        }
      }).post("/" + url, data);
    }
  }

  OPTICAL_CRM_GET(URL) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    } else {
      return axios.create({
        baseURL: "https://api.opticalcrm.com",
        headers: {
          "Content-type": "application/json",
          "Token": localGetItem("OPTICAL_CRM_API_TOKEN")
        }
      }).get("/" + URL);
    }
  }

  QR_REGISTRATION_POST_WITH_URL(url, data) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    } else {
      return axios.create({
        baseURL: BASE_DOMAIN,
        headers: {
          "Content-type": "application/json",
        }
      }).post("/" + url, data);
    }
  }
}

export default new RestAPIService();